import React, { useState } from "react";
import "./ImageCarousel.css";

const ImageCarousel = ({ ImageSlider }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  console.log(ImageSlider);

  const slideStyles = {
    width: "100%",
    height: "100%",
    borderRadius: "10px",
    // backgroundPosition: "center",
    // backgroundSize: "cover",
    // badkground:"round" - backgroundPosition & backgroundSize - duto kei position - center kore dei.
    background: "round",
    backgroundImage: `url(${ImageSlider[currentIndex].url})`,
    transition: "ease-in-out 0.4s",
  };

  const prevPhotoShow = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? ImageSlider.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };
  const nextPhotoShow = () => {
    const isLastSlide = currentIndex === ImageSlider.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <div className="slider">
      <p className="leftArrow">
        <i class="fa-solid fa-angle-left" onClick={prevPhotoShow}></i>
      </p>
      <p className="rightArrow">
        <i class="fa-solid fa-angle-right" onClick={nextPhotoShow}></i>
      </p>
      <div style={slideStyles}></div>
    </div>
  );
};

export default ImageCarousel;
